// extracted by mini-css-extract-plugin
module.exports = {"container":"Clock_container__34nG0","selectRow":"Clock_selectRow__1Wwce","time":"Clock_time__2ekY3"};